<template>

    <rkm-form ref="Form">

        <rkm-row>
            <rkm-col class="flex-grow-1" v-if="cota.laboratorioQuantidade || cota.laboratorioValor">

                <rkm-area
                    title="Cota - Laboratório"
                    type="fieldset"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col
                            cols="6"
                            v-if="cota.laboratorioQuantidade"
                            :class="cota.laboratorioQuantidade.saldo < 1 ? 'text-danger' : ''"
                        >
                            Quantidade: {{ cota.laboratorioQuantidade.percentualRestante }}% restante
                        </rkm-col>

                        <rkm-col
                            cols="6"
                            v-if="cota.laboratorioValor"
                            :class="cota.laboratorioValor.saldo < 1 ? 'text-danger' : ''"
                        >
                            Valor: {{ cota.laboratorioValor.percentualRestante }}% restante
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col class="flex-grow-1" v-if="cota.unidadeSolicitanteQuantidade || cota.unidadeSolicitanteValor">

                <rkm-area
                    title="Cota - Unidade solicitante"
                    type="fieldset"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col
                            cols="6"
                            v-if="cota.unidadeSolicitanteQuantidade"
                            :class="cota.unidadeSolicitanteQuantidade.saldo < 1 ? 'text-danger' : ''"
                        >
                            Quantidade: {{ cota.unidadeSolicitanteQuantidade.percentualRestante }}% restante
                        </rkm-col>

                        <rkm-col
                            cols="6"
                            v-if="cota.unidadeSolicitanteValor"
                            :class="cota.unidadeSolicitanteValor.saldo < 1 ? 'text-danger' : ''"
                        >
                            Valor: {{ cota.unidadeSolicitanteValor.percentualRestante }}% restante
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
     </rkm-form>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

// Mixins.
import { repository, error, object, data, formats, stringCase } from '@/mixins'

export default {
    created() {

        this.repositories = {
            agendamento: this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
        }

        this.load()
    },
    data:() => ({
        enums: {
            tipoCota,
            tipoUnidade
        },
        cota: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

                this.repositories.agendamento.getCotas({
                    infraestrutura_id: this.agendamento.infraestruturaId,
                    laboratorio_infraestrutura_id: this.agendamento.laboratorioInfraestruturaId,
                    agendamento_id: this.agendamento.agendamentoId,
                    data: this.itemSelecionado.data.split("/").reverse().join("-")
                })
                    .then(response => {
                        this.cota = response.data
                        this.$emit('handleSaldo', response.data)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
    },
    mixins: [ repository, error, object, data, formats, stringCase ],
    props: {
        itemSelecionado: { type: Object, required: true },
        agendamento: { type: Object, required: true },
    },
}
</script>